/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `company` - Company
* `supplier` - Supplier
* `third_party` - Third-party
* `client` - Client
* `downstream` - Downstream
 */
export type StorageManagedByEnum = typeof StorageManagedByEnum[keyof typeof StorageManagedByEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorageManagedByEnum = {
  company: 'company',
  supplier: 'supplier',
  third_party: 'third_party',
  client: 'client',
  downstream: 'downstream',
} as const;
